import { render, staticRenderFns } from "./addTableKey.vue?vue&type=template&id=b59b5b08&scoped=true&"
import script from "./addTableKey.vue?vue&type=script&lang=js&"
export * from "./addTableKey.vue?vue&type=script&lang=js&"
import style0 from "./addTableKey.vue?vue&type=style&index=0&id=b59b5b08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59b5b08",
  null
  
)

export default component.exports